const FLAG_SOURCE_LABELS: Record<CMxAPI.FlagItemSource, string> = {
  encounter: 'Encounter',
  patient: 'Patient'
};

export const getFlagSourceLabel = (
  flagSrc?: CMxAPI.FlagItemSource[]
): string | null => {
  if (!flagSrc?.length) {
    return null;
  }

  if (isPatientOnlyFlag(flagSrc)) {
    return FLAG_SOURCE_LABELS.patient;
  }

  if (flagSrc.includes('encounter')) {
    return FLAG_SOURCE_LABELS.encounter;
  }

  return null;
};

export const isPatientOnlyFlag = (
  flagSrc?: CMxAPI.FlagItemSource[]
): boolean =>
  flagSrc?.length === 1 && flagSrc[0] === 'patient';

export const getFlagItemTitle = (item: CMxAPI.FlagItem): string => {
  const sourceLabel = getFlagSourceLabel(item.flag_src);
  return sourceLabel ? `${item.flag} (${sourceLabel})` : item.flag;
};

export const getFlagItemKey = (item: CMxAPI.FlagItem, index: number): string =>
  `flag-${item.flag_type}-${item.flag}-${item.alternate_visit_id}-${index}`;
